import {useState, useEffect} from 'react';
import {db} from '../firebase/firebaseConfig';
import {useAuth} from '../context/AuthContext';
import { collection, onSnapshot, query, where } from 'firebase/firestore';

const usePayment = (id) => {
	const [payment, setPayment] = useState([]);
	const {usuario} = useAuth();

	useEffect(() => {
		if(usuario){
			const queryDB = query(
				collection(db, 'payments'),				
				where('mainPayment', '==', id)
			);

			const unsuscribe = onSnapshot(queryDB, (snapshot) => {
				setPayment(snapshot.docs.map((documento) => {
					return {...documento.data(), id: documento.id}
				}))
			}, (error) => {return error});

			return unsuscribe;
		}
	}, [usuario, id]);

	return payment;
}
 
export default usePayment;